<template>
  <div class="body">
    <el-container>
      <left-meun ref="_leftMeun" @initData="initData"></left-meun>
      <el-container>
        <el-header class="header_layout">
          <headerLayout :title="meunTitle"></headerLayout>
        </el-header>
        <el-main class="main">
          <div class="main_head">
            <div class="main_head_left">
              <div>
                <div class="input_parent">
                  <el-input
                    class="input"
                    v-model="where_student_no"
                    placeholder="请输入"
                    size
                  ></el-input>
                  <span>学号:</span>
                </div>
                <div class="input_parent">
                  <el-input
                    class="input"
                    v-model="where_name"
                    placeholder="请输入"
                    size
                  ></el-input>
                  <span>姓名:</span>
                </div>
                <div class="input_parent">
                  <el-select
                    class="input"
                    v-model="where_programme"
                    placeholder="请选择"
                    multiple
                    collapse-tags
                  >
                    <el-option
                      v-for="item in programmeOptions"
                      :key="item"
                      :value="item"
                    ></el-option>
                  </el-select>
                  <span>专业:</span>
                </div>
                <div class="input_parent">
                  <el-select
                    class="input"
                    v-model="where_education_status"
                    placeholder="请选择"
                    multiple
                    collapse-tags
                  >
                    <el-option
                      v-for="item in eduStatusOptions"
                      :key="item"
                      :value="item"
                    ></el-option>
                  </el-select>
                  <span>状态:</span>
                </div>
              </div>

              <div v-show="queryMoreShowFlag">
                <div>
                  <div class="input_parent">
                    <el-cascader
                      class="input input_daterange"
                      v-model="where_region"
                      :options="regionOptions"
                      :props="{ expandTrigger: 'hover' }"
                      @change="handleRegionChange"
                      clearable
                      filterable
                    ></el-cascader>
                    <span>所在地:</span>
                  </div>
                  <div class="input_parent">
                    <el-input
                      class="input"
                      v-model="where_education_school"
                      placeholder="请输入"
                      size
                    ></el-input>
                    <span>院校名称:</span>
                  </div>
                  <div class="input_parent">
                    <!-- <el-select
                      class="input"
                      v-model="where_education_programme"
                      placeholder="请选择"
                      multiple
                      collapse-tags
                    >
                      <el-option
                        v-for="item in programmeOptions"
                        :key="item"
                        :value="item"
                      ></el-option>
                    </el-select> -->
                    <el-input
                      class="input"
                      v-model="where_education_programme"
                      placeholder="请输入"
                    ></el-input>
                    <span>院校专业:</span>
                  </div>
                  <div class="input_parent">
                    <el-input
                      class="input"
                      v-model="where_mobile_phone"
                      placeholder="请输入"
                      size
                    ></el-input>
                    <span>联系电话:</span>
                  </div>
                  <div class="input_parent">
                    <el-input
                      class="input"
                      v-model="where_wechat"
                      placeholder="请输入"
                      size
                    ></el-input>
                    <span>微信:</span>
                  </div>
                  <div class="input_parent">
                    <el-input
                      class="input"
                      v-model="where_origin_place"
                      placeholder="请输入"
                      size
                    ></el-input>
                    <span>生源地:</span>
                  </div>
                  <div class="input_parent">
                    <el-input
                      class="input"
                      v-model="where_education_other"
                      placeholder="请输入"
                      size
                    ></el-input>
                    <span>其他:</span>
                  </div>
                  <div class="input_parent">
                    <el-select
                      class="input"
                      v-model="where_alumni_type"
                      placeholder="请选择"
                      multiple
                      collapse-tags
                    >
                      <el-option
                        v-for="item in alumniTypeOptions"
                        :key="item"
                        :value="item"
                      ></el-option>
                    </el-select>
                    <span>校友类别:</span>
                  </div>
                  <div class="input_parent input_parent_Max">
                    <el-date-picker
                      class="input input_daterange"
                      v-model="where_education_graduation_year"
                      value-format="yyyy"
                      style="width: 69%"
                      type="monthrange"
                    ></el-date-picker>
                    <span>毕业年份:</span>
                  </div>
                  <div class="input_parent input_parent_Max">
                    <el-date-picker
                      class="input input_daterange"
                      v-model="where_year"
                      value-format="yyyy"
                      style="width: 69%"
                      type="monthrange"
                    ></el-date-picker>
                    <span>本校入学年份:</span>
                  </div>
                  <div class="input_parent input_parent_Max">
                    <el-date-picker
                      class="input input_daterange"
                      v-model="where_graduation_year"
                      value-format="yyyy"
                      style="width: 69%"
                      type="monthrange"
                    ></el-date-picker>
                    <span>本校毕业年份:</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="main_head_right">
              <el-button type="primary" @click="query()">查询</el-button>
              <el-button @click="reset()">重置</el-button>
              <el-button type="text" @click="queryMoreShow()">{{
                queryMoreShowTitle
              }}</el-button>
              <span
                v-bind:class="[
                  queryMoreShowFlag ? 'el-icon-arrow-up' : 'el-icon-arrow-down'
                ]"
                @click="queryMoreShow()"
              ></span>
            </div>
          </div>
          <div style="clear: both"></div>
          <div style="margin-top: 10px">
            <el-dropdown
              @command="handleDialogCommand"
              placement="bottom-start"
            >
              <el-button>
                <i class="el-icon-s-operation el-icon--left"></i> 批量操作
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="exportSelect"
                  >导出选中信息</el-dropdown-item
                >
                <el-dropdown-item command="exportAisEducation"
                  >导出查询列表</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
            <i
              class="el-icon-setting setTabBabel"
              style="margin-top: 10px"
              @click="showSetTabBabelDrawer()"
            ></i>
          </div>
          <div class="selectTitle" v-if="selectSize > 0">
            <span class="el-icon-info" style="color: #2383e0"></span>
            <span style="margin-left: 10px">已选择</span>
            <span class="selectTitleNum">{{ selectSize }}</span>
            <span>条信息</span>
            <el-button
              type="text"
              class="selectTitleClear"
              @click="cleanTable()"
              >清空</el-button
            >
          </div>
          <el-table
            v-loading="tableLoading"
            ref="multipleTable"
            :data="tableData"
            @sort-change="changeTableSort"
            tooltip-effect="dark"
            style="width: 100%"
            @row-click="toUserDetails"
            @selection-change="handleSelectionChange"
            :default-sort="{ prop: 'date', order: 'descending' }"
          >
            <el-table-column type="selection" min-width="1"></el-table-column>
            <el-table-column
              prop="student_no"
              v-if="checkList.indexOf('学号') > -1"
              label="学号"
              min-width="2"
              sortable="custom"
            ></el-table-column>
            <el-table-column
              prop="name_cn"
              v-if="checkList.indexOf('中文姓名') > -1"
              label="中文姓名"
              min-width="2"
              sortable="custom"
            ></el-table-column>
            <el-table-column
              prop="name_en"
              v-if="checkList.indexOf('英文姓名') > -1"
              label="英文姓名"
              min-width="2"
              sortable="custom"
            ></el-table-column>
            <el-table-column
              prop="programme"
              v-if="checkList.indexOf('专业') > -1"
              label="专业"
              min-width="2"
              sortable="custom"
            ></el-table-column>
            <el-table-column
              prop="education_status"
              v-if="checkList.indexOf('状态') > -1"
              label="状态"
              min-width="2"
              sortable="custom"
            ></el-table-column>
            <el-table-column
              prop="location"
              v-if="checkList.indexOf('所在地') > -1"
              label="所在地"
              min-width="3"
              sortable="custom"
            ></el-table-column>
            <el-table-column
              prop="education_school"
              v-if="checkList.indexOf('院校名称') > -1"
              label="院校名称"
              min-width="3"
              sortable="custom"
            ></el-table-column>
            <el-table-column
              prop="education_programme"
              v-if="checkList.indexOf('院校专业') > -1"
              label="院校专业"
              min-width="2"
              sortable="custom"
            ></el-table-column>
            <el-table-column
              prop="education_graduation_year"
              v-if="checkList.indexOf('毕业年份') > -1"
              label="毕业年份"
              min-width="2"
              sortable="custom"
            ></el-table-column>
            <el-table-column
              prop="mobile_phone"
              v-if="checkList.indexOf('联系电话') > -1"
              label="联系电话"
              min-width="2"
              sortable="custom"
            ></el-table-column>
            <el-table-column
              prop="wechat"
              v-if="checkList.indexOf('微信') > -1"
              label="微信"
              min-width="2"
              sortable="custom"
            ></el-table-column>
            <el-table-column
              prop="origin_place"
              v-if="checkList.indexOf('生源地') > -1"
              label="生源地"
              min-width="2"
              sortable="custom"
            ></el-table-column>
            <el-table-column
              prop="alumni_type"
              v-if="checkList.indexOf('校友类别') > -1"
              label="校友类别"
              min-width="2"
              sortable="custom"
            ></el-table-column>
            <el-table-column
              prop="is_bachelors_masters"
              v-if="checkList.indexOf('是否本硕连读') > -1"
              label="是否本硕连读"
              min-width="2"
            ></el-table-column>
            <el-table-column
              prop="education_other"
              v-if="checkList.indexOf('其他') > -1"
              label="其他"
              min-width="2"
              sortable="custom"
            ></el-table-column>
          </el-table>
          <div class="elPaginationDiv">
            <el-pagination
              :key="elementui_page_key"
              class="elPagination"
              background
              layout="prev, pager, next"
              :page-size="pageMaxSize"
              :page-count="pageCount"
              :current-page="currentPage"
              @current-change="currentChange"
            ></el-pagination>
            <span class="paginationPageNum"
              >第{{ thispageNum }}条，总共{{ recordCount }}条</span
            >
          </div>
        </el-main>
        <export-ais-education-dialog
          ref="_exportAisEducationDialog"
        ></export-ais-education-dialog>
        <educations-table-label-drawer
          ref="_educationsTableLabelDrawer"
          @toBackCheckList="backCheckList"
        ></educations-table-label-drawer>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import { URL_PATH, LIST_PAGE_MAX_SIZE } from "@/config/config";
import * as Constant from "@/utils/constant.js";
import * as CRegion from "@/utils/constant_region.js";
import * as StrUtils from "@/utils/strUtils.js";
import * as CApi from "@/api/constant_api.js";
import * as Api from "@/api/api.js";
import leftMeun from "@/components/layout/leftMeun";
import headerLayout from "@/components/layout/headerLayout";
import headRight from "@/components/layout/headRight";
import exportAisEducationDialog from "@/components/dialog/exportAisEducationDialog";
import educationsTableLabelDrawer from "@/components/drawer/educationsTableLabelDrawer";

var multipleSelectionMap = new Map(); // 多页选中数组总数

export default {
  components: {
    leftMeun,
    headerLayout,
    headRight,
    exportAisEducationDialog,
    educationsTableLabelDrawer
  },
  data() {
    return {
      tableLoading: false,
      meunTitle: " 深造信息列表",
      queryMoreShowFlag: false,
      queryMoreShowTitle: "展开",
      timeOutTimer: "",
      pageMaxSize: LIST_PAGE_MAX_SIZE,
      pageCount: 0,
      selectSize: 0,
      recordCount: 0,
      thispageNum: "1-" + LIST_PAGE_MAX_SIZE,
      otherPageSelectSize: 0, //其他页选中的数量
      changExcelDialogVisible: false,
      changSiDialogVisible: false,
      changeExportInfoDialog: false,
      exportAisEducationRequest: false,

      currentPage: 1,
      order: "",
      where_student_no: "",
      where_name: "",
      where_programme: [],
      where_education_status: [],
      where_education_nation: "",
      where_education_province: "",
      where_education_city: "",
      where_education_school: "",
      where_education_programme: "",
      where_education_graduation_year: [],
      where_year: [],
      where_graduation_year: [],
      where_education_other: "",
      where_region: [],
      where_mobile_phone: "",
      where_wechat: "",
      where_origin_place: "",
      where_alumni_type: [],

      yearOptions: [], //入学年份
      regionOptions: JSON.parse(localStorage.getItem("options_region")),
      eduStatusOptions: Constant.edu_status_options,
      programmeOptions: Constant.programme_options,
      tableData: [],
      multipleSelection: [], // 单页选中数组
      checkList: Constant.educations_table_lable,
      checkListAll: Constant.educations_table_lable,
      alumniTypeOptions: []
    };
  },
  mounted() {
    var that = this;
    document.onkeydown = function(e) {
      const keyCode = event.keyCode
        ? event.keyCode
        : event.which
        ? event.which
        : event.charCode;
      // 回车键查询
      if (keyCode == 13) that.query();
    };
  },
  created() {
    this.elementui_page_key++;
    CRegion.regionPutAllOptions(this.regionOptions);
  },
  methods: {
    initData(meunItem) {
      this.meunItem = meunItem;
      this.meunTitle = this.meunItem.name;
      // 获取操作日志列表
      this.getAisEducation();
      this.getProgrammeOptions();
      this.getAlumniTypeOptions();
    },
    showSetTabBabelDrawer() {
      this.$nextTick(() => {
        this.$refs._educationsTableLabelDrawer.show(this.checkList);
      });
    },
    exportList() {
      let ids = this.getUserIds();
      if (ids.length == 0) {
        this.$message.error("至少选中一条数据");
        return;
      }
      ids = JSON.stringify(ids);
      this.$nextTick(() => {
        this.$refs._exportAisEducationDialog.show(
          this.checkList,
          this.order,
          this.where_student_no,
          this.where_name,
          this.where_programme,
          this.where_education_status,
          this.where_education_programme,
          this.where_education_nation,
          this.where_education_province,
          this.where_education_city,
          this.where_education_school,
          this.where_education_graduation_year,
          this.where_year,
          this.where_graduation_year,
          this.where_education_other,
          this.where_mobile_phone,
          this.where_wechat,
          this.where_origin_place,
          this.where_alumni_type,
          ids
        );
      });
    },
    exportAisEducation() {
      if (this.recordCount == 0) {
        this.$message.error("列表无数据，无法导出");
        return;
      }
      this.$nextTick(() => {
        this.$refs._exportAisEducationDialog.show(
          this.checkList,
          this.order,
          this.where_student_no,
          this.where_name,
          this.where_programme,
          this.where_education_status,
          this.where_education_programme,
          this.where_education_nation,
          this.where_education_province,
          this.where_education_city,
          this.where_education_school,
          this.where_education_graduation_year,
          this.where_year,
          this.where_graduation_year,
          this.where_education_other,
          this.where_mobile_phone,
          this.where_wechat,
          this.where_origin_place,
          this.where_alumni_type
        );
      });
    },
    // 查看学生详情 details
    toUserDetails(row, column, event) {
      Api.verifyApi(CApi.api_getAisInfoById, verify => {
        if (verify) {
          this.meunItem.userid = row.id;
          localStorage.setItem("meunItem", JSON.stringify(this.meunItem));
          this.$router.push({path:"/data/user-details",query:{id:row.id}});
        }
      });
    },
    // 选择列表显示字段
    backCheckList(list) {
      this.checkList = list;
    },
    // 批量操作弹窗
    handleDialogCommand(command) {
      let _this = this;
      switch (command) {
        case "exportAisEducation":
          Api.verifyApi(CApi.api_exportAisEducation, verify => {
            if (verify) {
              this.exportAisEducationRequest = true;
              this.getAisEducation();
            }
          });
          break;
        case "exportSelect":
          Api.verifyApi(CApi.api_exportAisEducation, verify => {
            if (verify) {
              this.exportList();
            }
          });
          break;
      }
    },
    // 地区选择
    handleRegionChange(value) {
      console.log(value);
      this.where_education_nation = value[0];
      if (value.length > 1) this.where_education_province = value[1];
      if (value.length > 2) this.where_education_city = value[2];
    },
    currentChange(val) {
      this.elementui_page_key++;
      this.otherPageSelectSize += this.multipleSelection.length;
      multipleSelectionMap.set(this.currentPage, this.multipleSelection);
      console.log(multipleSelectionMap);

      this.otherPageSelectSize = 0;
      var that = this;
      multipleSelectionMap.forEach(function(key, value, index) {
        if (value != val) {
          that.otherPageSelectSize += key.length;
        }
      });
      this.currentPage = val;
      this.getAisEducation();
    },
    // 列表选中监听
    handleSelectionChange(selection) {
      this.multipleSelection = selection;
      this.setShowBatchBtnState(this.multipleSelection.length);
    },
    // 排序
    changeTableSort(column) {
      if ("location" == column.prop) {
        this.order = StrUtils.getLocationPropOrder(column, "education");
      } else {
        this.order = StrUtils.getPropOrder(column);
      }
      this.query();
    },
    // 服务端获取数据
    getAisEducation: function() {
      this.tableLoading = true;
      this.$api
        .getAisEducation({
          token: localStorage.getItem("token"),
          page: this.currentPage,
          limit: this.pageMaxSize,

          order: this.order,
          where_student_no: this.where_student_no,
          where_name: this.where_name,
          where_education_programme: this.where_education_programme,
          where_education_nation: this.where_education_nation,
          where_education_province: this.where_education_province,
          where_education_city: this.where_education_city,
          where_education_school: this.where_education_school,
          where_education_other: this.where_education_other,

          where_programme: StrUtils.replaceFields(
            this.where_programme.toString()
          ),
          where_education_status: StrUtils.replaceFields(
            this.where_education_status.toString()
          ),
          where_education_graduation_year:
            this.where_education_graduation_year == undefined ||
            this.where_education_graduation_year.length == 0
              ? ""
              : this.where_education_graduation_year[0] +
                "-" +
                this.where_education_graduation_year[1],
          where_year:
            this.where_year == undefined || this.where_year.length == 0
              ? ""
              : this.where_year[0] + "-" + this.where_year[1],
          where_graduation_year:
            this.where_graduation_year == undefined ||
            this.where_graduation_year.length == 0
              ? ""
              : this.where_graduation_year[0] +
                "-" +
                this.where_graduation_year[1],
          where_mobile_phone: this.where_mobile_phone,
          where_wechat: this.where_wechat,
          where_origin_place: this.where_origin_place,
          where_alumni_type: StrUtils.replaceFields(
            this.where_alumni_type.toString()
          )
        })
        .then(({ data }) => {
          this.recordCount = data.Data.recordCount;
          var currentPage = data.Data.currentPage;
          var startIndex = (currentPage - 1) * this.pageMaxSize + 1;
          var endIndex = startIndex + this.pageMaxSize - 1;
          if (endIndex > this.recordCount) {
            endIndex = this.recordCount;
          }
          this.thispageNum = startIndex + "-" + endIndex;
          this.pageCount = data.Data.pageCount;
          this.tableData = data.Data.model;
          this.tableData.forEach(info => {
            info.location = StrUtils.getEduLocation(info);
            info.is_bachelors_masters = StrUtils.yesOrNo(
              info.is_bachelors_masters
            );
          });
          this.timeOutTimer = setTimeout(this.toggleRowSelectionn, 10);
          this.tableLoading = false;
          if (this.exportAisEducationRequest) {
            this.exportAisEducation();
          }
          this.exportAisEducationRequest = false;
        })
        .catch(({ error }) => {
          this.tableLoading = false;
          this.exportAisEducationRequest = false;
          if (error != undefined) {
            console.log(error);
          }
        });
    },
    // 获取入学年份
    getYearOptions: function() {
      this.$api
        .getColumnValue({
          token: localStorage.getItem("token"),
          field: "year"
        })
        .then(({ data }) => {
          console.log(data);
          this.yearOptions = data.Data.year;
        })
        .catch(({ error }) => {
          console.log(error);
        });
    },
    // 获取专业
    getProgrammeOptions: function() {
      this.$api
        .getColumnValue({
          token: localStorage.getItem("token"),
          field: "programme"
        })
        .then(({ data }) => {
          this.programmeOptions = data.Data.programme;
        })
        .catch(({ error }) => {
          console.log(error);
        });
    },
    // 获取校友类别
    getAlumniTypeOptions() {
      this.$api
        .bindAisInfoFieldArr({ field: "alumni_type" })
        .then(({ data }) => {
          this.alumniTypeOptions = data.Data.alumni_type;
        })
        .catch(({ error }) => {
          console.log(error);
        });
    },
    // 恢复勾选已选中
    toggleRowSelectionn() {
      if (multipleSelectionMap.size == 0) return;
      var array = multipleSelectionMap.get(this.currentPage);
      if (array == undefined || array.length == 0) return;
      var arr = JSON.parse(JSON.stringify(array));
      this.tableData.forEach(tData => {
        arr.forEach(tData1 => {
          if (tData.education_id === tData1.education_id) {
            this.$refs.multipleTable.toggleRowSelection(tData, true);
          }
        });
      });
    },
    // 批量操作显示状态修改
    setShowBatchBtnState(size) {
      this.selectSize = size + this.otherPageSelectSize;
    },
    // 获取选中的用户id 数组
    getUserIds: function() {
      multipleSelectionMap.set(this.currentPage, this.multipleSelection);
      var userIds = [];
      multipleSelectionMap.forEach(function(key, value, index) {
        key.forEach(user => {
          userIds.push(user.education_id);
        });
      });
      return userIds;
    },
    // 查询
    query: function() {
      this.currentPage = 1;
      this.getAisEducation();
    },
    // 搜索重置
    reset: function() {
      this.$refs.multipleTable.clearFilter();
      multipleSelectionMap.clear();

      this.order = "";
      this.where_student_no = "";
      this.where_name = "";
      this.where_programme = [];
      this.where_education_status = [];
      this.where_education_nation = "";
      this.where_education_province = "";
      this.where_education_city = "";
      this.where_education_school = "";
      this.where_education_programme = "";
      this.where_education_graduation_year = [];
      this.where_year = [];
      this.where_graduation_year = [];
      this.where_education_other = "";
      this.where_region = [];
      this.where_mobile_phone = "";
      this.where_wechat = "";
      this.where_origin_place = "";
      this.where_alumni_type = [];
      this.exportAisEducationRequest = false;
      this.otherPageSelectSize = 0;
      this.setShowBatchBtnState(0);
      this.query();
    },
    queryMoreShow() {
      this.queryMoreShowFlag = !this.queryMoreShowFlag;
      this.queryMoreShowTitle = this.queryMoreShowFlag ? "收起" : "展开";
    },
    //清空已选表格
    cleanTable: function() {
      multipleSelectionMap.clear();
      this.otherPageSelectSize = 0;
      this.setShowBatchBtnState(0);
      this.$refs.multipleTable.clearSelection();
    }
  },
  beforeDestroy() {
    clearTimeout(this.timeOutTimer);
  }
};
</script>

<style lang="less" scoped>
.main {
  margin: 10px 20px;
  background-color: #fff;
  border-radius: 5px;
}
.main_head {
  width: 100%;
}
.main_head_left {
  margin-left: -20px;
  width: 85%;
  float: left;
}
.selectTitle {
  padding-left: 10px;
  margin-top: 15px;
  background-color: #eff9fe;
  border-radius: 3px;
  border: 1px solid #2383e0;
  height: 40px;
  line-height: 40px;
}
.selectTitleNum {
  color: #2383e0;
}
.selectTitleClear {
  color: #2383e0;
  margin-left: 20px;
  cursor: hand;
}
</style>



// WEBPACK FOOTER //
// src/pages/dataMgr/listEducations.vue